import React, { ComponentState, ReactNode, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { cupolaT } from '../../../utils/listCupola';
import Select, { components } from "react-select";
//@ts-ignore
import s from './GroupCupola.module.scss'
import { BlaskCupola } from '../../../asset/cupola/BlaskCupola';
import { CopperColorRoof } from '../../../asset/cupola/CopperColorRoof';
import { DeluxeCupola } from '../../../asset/cupola/DeluxeCupola';
import { DeleteIcon } from '../../../asset/icon/DeleteIcon';
import { setValueMultipleOptions, setValueOptions } from '../../../store/actions/setting';

import { getValueMultipleOption, valueMultipleOption } from '../../../store/selectors/selectors';
import { filter, includes } from 'ramda';

// import { BlaskCupola } from "../asset/cupola/BlaskCupola";
// import { CopperColorRoof } from "../asset/cupola/CopperColorRoof";
// import { DeluxeCupola } from "../asset/cupola/DeluxeCupola";

const customStyles = {
    option: (provided: any, state: any) => {
        let value = state.getValue()
        // debugger

        provided = {
            ...provided,
            padding: '13px 20px',
            background: '#fff !important',
            transition: '0.3s',
            "&:hover": {
                background: ' #F9F9F9 !important',
                cursor: 'pointer'
            },


        }
        return { ...provided };
    },
    control: (provided: any, state: any) => {
        let menuIsOpen = state['menuIsOpen'];
        provided = {
            ...provided,
            borderRadius: '15px',
            borderBottomLeftRadius: menuIsOpen ? '0' : '15px',
            borderBottomRightRadius: menuIsOpen ? '0' : '15px',

            borderColor: '#DEDEDE !important',
            boxShadow: '0 0 1px #DEDEDE !important'
        }
        return { ...provided };
    },
    indicatorSeparator: (provided: any, state: any) => {
        provided = {
            ...provided,
            backgroundColor: 'transparent',

        }
        return { ...provided };
    },
    singleValue: (provided: any, state: any) => {

        return { ...provided };
    },
    menu: (provided: any, state: any) => {

        provided = {
            ...provided,
            marginBottom: '0px',
            marginTop: '0px',
            borderTopLeftRadius: '0',
            borderTopRightRadius: '0',
            borderTop: 'none',
            border: '1px solid #DEDEDE',
            boxShadow: 'none'
        }

        return { ...provided };
    },
    placeholder: (provided: any, state: any) => {

        provided = {
            ...provided,
            marginLeft: '0px',
            left: '16px',
            fontSize: '15px',
            lineHeight: 1.3,
            color: '#6a6a63',
            Left: '16px',
            position: 'absolute',
        }
        return { ...provided };
    },

}

type GroupCupolaT = {
    values: cupolaT[],
    id: string,
    [key: string]: unknown
}



export const getCupola: ComponentState = (type: string) => {
    switch (type) {
        case 'BlaskCupola': return BlaskCupola
        case 'CopperColorRoof': return CopperColorRoof
        case 'DeluxeCupola': return DeluxeCupola
    }
}

const MultiValueRemove = () => {
    return (<></>)
};
const IndicatorsContainer = ({ ...props }: any) => {
    let { isDisabled, isMulti, isRtl } = props
    // debugger
    return (
        <components.IndicatorsContainer {...props} />)
};
const SingleValue = () => {
    return (<div className={`${s.singleValue}`}>+ Add Item</div>)
};

const Option = (selectValue: any) => (props: any) => {
    const { data, children } = props;

    let isActive = [];
    // let allItems = selectValue
    if (Array.isArray(selectValue)) {

        isActive = selectValue.filter((item: cupolaT) => item['value'] === data['value']);
    }
    // debugger
    if (isActive.length > 0) return (<></>)
    // debugger
    let isSelectedT = isActive.length > 0;

    let classOption = `${s.option}`
    if (isSelectedT) classOption += ` ${s.optionActive}`
    return (
        <components.Option {...props}   >
            <div className={s.option}>
                <div className={s.img}>
                    {React.createElement(getCupola(data['imgComponent']))}
                </div>
                <div className={s.label}>{data['label']}</div>
            </div>
        </components.Option>
    )
};

type CupolaT = {
    onRemove: any
} & cupolaT
export const Cupola = ({ ...props }: CupolaT) => {
    const { label, onRemove, imgComponent } = props

    return (
        <div className={s.cupola}>
            <div className={s.img}>
                {React.createElement(getCupola(imgComponent))}
            </div>
            <div className={s.footer}>
                <div className={s.name}>{label}</div>
                <div className={s.remote} onClick={() => onRemove()}>
                    <div className={s.icon}><DeleteIcon /></div>
                    <div className={s.name}>Remove</div>
                </div>
            </div>
        </div>
    )
}

type valueGroupCupolaT = {
    selectValue: cupolaT[] | any
    [key: string]: any
}
export const GroupCupola = ({ ...props }: GroupCupolaT) => {

    const dispatch = useDispatch();

    let { id, values } = props

    let { selectValue, isError }: valueGroupCupolaT = useSelector(state => getValueMultipleOption(id)(state));

    const onChange = (value: any) => {
        dispatch(setValueOptions({ idParams: id, valueParam: value }))
    }
    const onRemoveCupola = ({ selectValue, value }: any) => {
        let newListCupolas = selectValue.filter((item: cupolaT) => item['value'] !== value['value'])
        dispatch(setValueOptions({ idParams: id, valueParam: newListCupolas }))
    }

    useEffect(() => {

    }, [selectValue])

    return (
        <div className={s.GroupCupola}>
            <div className={s.header}>
                <div className={s.label}>Cupola</div>
                <div className={s.selectWrap}>
                    <Select
                        className={s.selectBox}
                        styles={customStyles}
                        value={selectValue}
                        onChange={value => onChange(value)}
                        options={values}
                        // menuIsOpen={true}
                        isMulti
                        placeholder={'+ Add Item'}
                        components={
                            {
                                'MultiValue': SingleValue,
                                'SingleValue': SingleValue,
                                'Option': Option(selectValue),
                                'MultiValueRemove': MultiValueRemove,
                                'ClearIndicator': MultiValueRemove,
                            }
                        }
                    />
                </div>
            </div>
            <div className={s.main}>
                <div className={s.values}>
                    {values.map((cupola: cupolaT) => {
                        if (Array.isArray(selectValue)) {
                            return includes(cupola, selectValue) && (<Cupola onRemove={() => onRemoveCupola({ selectValue, value: cupola })} {...cupola} key={cupola['value']} />)
                        }
                    })}
                </div>
            </div>
        </div>
    )
}


